<div class="form-group single-checkbox glu-switch switch-md switch-square">
    <span>{{label}}</span>
    <input id="multi-column-sort-select-{{gridId}}" class="multi-column-sort-select" type="checkbox">
    <label for="multi-column-sort-select-{{gridId}}" data-on="On" data-off="Off">{{label}}</label>
</div>
<div class="multi-column-sort-manage">
    |
    <a class="disabled">{{locale "manage"}}</a>
</div>